import { BookMeetingResponse } from '../api';
import { JOIN_STATUS, OPEN_MEETING_MESSAGES } from '../constants';

export const OPEN_MEETING_FULL_MESSAGE = OPEN_MEETING_MESSAGES.FULL;
export const OPEN_MEETING_REGISTERING_MESSAGE = OPEN_MEETING_MESSAGES.REGISTERING;

export const isOpenMeetingRegistrationFull = (joinStatus?: string): boolean =>
  joinStatus === JOIN_STATUS.REGISTRATION_FULL;

export const isAudienceCapacityEnabled = (audienceCapacityEnabled?: boolean): boolean =>
  audienceCapacityEnabled === true;

export const isCapEnabledAttendResponse = (
  response?: void | BookMeetingResponse | Record<string, never>
): response is BookMeetingResponse =>
  !!response &&
  typeof response === 'object' &&
  'registrationId' in response &&
  'appSyncToken' in response &&
  !!response.registrationId &&
  !!response.appSyncToken;

export const resolveRegisterJoinStatus = (joinStatus?: string): string =>
  joinStatus ?? JOIN_STATUS.NOT_JOINED;

export const resolveJoinStatusAfterLeave = (refreshedJoinStatus?: string): string => {
  if (refreshedJoinStatus === JOIN_STATUS.REGISTRATION_FULL) {
    return JOIN_STATUS.REGISTRATION_FULL;
  }
  return JOIN_STATUS.NOT_JOINED;
};
